import { Box, Modal } from '@mui/material';

import ModalStyle from '@/constants/ModalStyle';
import ButtonCloseModal from '@/components/ui/Button/ButtonCloseModal';
import ReactPlayer from 'react-player';

export default function Video(props) {
	const { video, open, onClose } = props;
	const { type, url, name, number } = video;

	return (
		<Modal open={open} onClose={onClose} aria-labelledby='modal-project-qr' aria-describedby='modal-project-qr' className='w-full'>
			<Box sx={{ ...ModalStyle, top: '25svh' }} className='relative flex flex-col w-auto h-auto gap-4'>
				<span className='text-2xl modal-title'>{number} {name}</span>
				<ButtonCloseModal onClose={onClose} />

				<hr />
				<div className='flex flex-col items-center justify-center w-full h-auto gap-4 text-center'>
					{url && type && (
						<ReactPlayer url={url} controls={true} width='100%' height='360px' />
					)}
				</div>
			</Box>
		</Modal>
	);
}
